<template>
    <div class="header-con head-bg relative"> 
        <div class="flex col-87">
            <div class="mar-l3">
                <div class="flex">
                    <img class="h-title" src="../assets/images/h-title.png" alt="">
                    <div class="font-40 mar-l1 font-bold">净水监控系统</div>
                </div>
                <div class="mar-l5 font-14">{{curDate.dateStr}} {{curTime}}</div>
            </div>
            <div class="header-c font-34 font-bold" v-if="wxPhone=='15881020886'"> 
                <div class="ui-flex-c">
                    <img src="../assets/images/hj-logo.png" alt="" class="mar-r2 wy-logo"/>
                    <div>好井</div> 
                </div> 
            </div> 
            <div class="header-c font-34 font-bold" v-else>{{proName}}</div> 
        </div>
    </div> 
</template>

<script>
export default {  
    props: {
        proName:{
            type: String,
            default: ''
        }, 
        wxPhone:{
            type: String,
            default: ''
        } 
    },
    data(){
        return { 
            title:'',
            timer: null,
            curDate:{},
            curTime:"", 
        }
    }, 
    methods: {
        removeCss(){ 
            let targetelement = "link";
            let targetattr = "href"; 
            let allsuspects = document.getElementsByTagName(targetelement);
            let filename = 'themeDispenser.css';
            if(allsuspects && allsuspects.length>0){  
                for (let i = 0;i<allsuspects.length;i++) {   
                if(allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1){ 
                    allsuspects[i].parentNode.removeChild(allsuspects[i]) 
                } 
                } 
            } 
            let user = JSON.parse(localStorage.getItem('user'))  
            if(user.phone)this.initCss(user.phone) 
        },
        initCss(phone){  
            const link = document.createElement('link');
            link.type = 'text/css';
            link.rel  = "stylesheet";  
            link.href = `http://cm.qingting1.com:8888/qtjs/screen/common/${phone}/css/themeTender.css`;  
            document.body.appendChild(link);
        }, 
        _initDate() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            month = month > 9 ? month : `0${month}`;
            let day = time.getDate();
            day = day > 9 ? day : `0${day}`;
            let weekDay = time.getDay();
            let week = this._getWeek(weekDay);
            let date = {
                week,
                dateStr: `${year}.${month}.${day}`
            }; 
            this.curDate = date;
        },
        _getWeek(day) {
            let weeks = new Array(
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            );
            let weekStr = weeks[day];
            return weekStr;
        },
        _initTime() {
            let time = new Date();
            let hour = time.getHours(); 
            let min = time.getMinutes();
            if(hour == 0 && min == 0)this._initDate();
            hour = hour > 9 ? hour : `0${hour}`;
            min = min > 9 ? min : `0${min}`;
            this.curTime = `${hour}:${min}`; 
        },
        initPage(){   
            this._initTime(); 
            this._initDate();
            this.timer = setInterval(() => {
                this._initTime();
            }, 1000);
        },  
    },
    created(){ 
        this.initPage();  
        setTimeout(()=>{ 
            this.removeCss(); 
        },500)
    },
    destroyed() { 
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        } 
    }
}
</script>

<style lang="scss" scoped> 
    .header-con{
        height: 5rem;
        width: 100%; 
        .header-c{
            position: absolute;
            width: 100%;
            text-align: center; 
        }
        .wy-logo{
            width: 8rem;
            height: 100%;
            margin-top: -0.625rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue